const baseGraphOptions = {
  plotOptions: {
    bar: {
      distributed: true,
    },
  },
  legend: {
    show: false,
  },
  states: {
    hover: {
      filter: {
        type: 'none',
        value: 0,
      },
    },
    active: {
      filter: {
        type: 'none',
        value: 0,
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    id: 'basic-bar',
  },
  grid: {
    show: false,
  },
  axis: {
    show: false,
  },
  axisBorder: {
    show: false,
  },
  labels: {
    show: false,
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
    },
    categories: [],
  },
};

/* HERO LINE GRAPH OPTIONS */
const heroLineGraphOptions = (data) => ({
  ...baseGraphOptions,
  colors: ['#E53935'],
  stroke: {
    width: 2,
  },
  markers: {
    size: 5,
    strokeColors: 'transparent',
    colors: ['transparent'],
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: data.length - 1,
        fillColor: '#E53935',
        strokeColor: '#E53935',
        size: 3,
      },
    ],
  },
});

const heroBarGraphOptions = (data) => {
  const colors = data.map((el, index) => {
    if (index !== data.length - 1) {
      return '#E5E5E5';
    }
    return '#00A064';
  });
  return {
    ...baseGraphOptions,
    fill: {
      colors,
    },
  };
};

export { heroLineGraphOptions, heroBarGraphOptions };
